import MDBox from "components/MDBox";
import { ETypeContent } from "../content.type";
import MapUpdate from "components/FormField/MapUpdate";

function SectionMap(): JSX.Element {
    return (
        <MDBox>
            <MDBox>
                <MapUpdate title="Zone Challenge" contentId={ETypeContent.mapZoneChallenge} />
                <MapUpdate title="Parc Brunet" contentId={ETypeContent.mapParcBrunet} />
                <MapUpdate title="Parc Récréonautique" contentId={ETypeContent.mapRecreo} />
                <MapUpdate title="Agora Naturelle" contentId={ETypeContent.mapAgora} />
                <MapUpdate title="Circuit Navette" contentId={ETypeContent.mapCircuit} />
                <MapUpdate title="Course à Pied" contentId={ETypeContent.mapCourse} />
            </MDBox>
        </MDBox>
    )
}

export default SectionMap;